module.exports = __webpack_public_path__ + "img/list.a9bda0d2.svg";